import React from 'react';
import servicesImage from '../images/home2.jpg';
import '../styles/Services.css'

interface Service {
  id: number;
  title: string;
  description: string;
}

interface ServicesProps {}

const Services: React.FC<ServicesProps> = () => {
  const services: Service[] = [
    { id: 1, title: 'Desenvolvimento Web', description: 'Criação de websites e aplicações web responsivas e performáticas.' },
    { id: 2, title: 'Desenvolvimento Mobile', description: 'Desenvolvimento de aplicativos nativos e híbridos para iOS e Android.' },
    { id: 3, title: 'Desenvolvimento de Software Personalizado', description: 'Soluções de software sob medida para as suas necessidades.' },
    { id: 4, title: 'Consultoria em Tecnologia', description: 'Orientação e expertise para otimizar seus processos de tecnologia.' },
  ];

  return (
        <div className='services-content' >
          <img src={servicesImage} alt="ilustrative work" className="services-image" />
          <div className="services-grid">
            <h2>Nossos Serviços</h2>
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <h3>{service.id}. {service.title}</h3>
                <p>{service.description}</p>
                {/* Adicione mais detalhes ou um link para cada serviço */}
              </div>
            ))}
          </div>
      </div>
  );
};


export default Services;